/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nNewHead.vue?vue&type=template&id=36215dd8&scoped=true"
import script from "./nNewHead.vue?vue&type=script&lang=js"
export * from "./nNewHead.vue?vue&type=script&lang=js"
import style0 from "./nNewHead.vue?vue&type=style&index=0&id=36215dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36215dd8",
  null
  
)

export default component.exports